import { createSelector } from 'reselect';

export const jobs = (store) => store.apps.jobs;

export const filtersSelector = createSelector([jobs], (jobsStore) => (jobsStore.filters));
